module.exports = __webpack_public_path__ + "static/map-deutschland-pin-16d69721a0aed63db21d707151ddae22.png";